import { Card, CardContent } from "@/components/ui/card";
import { LucideIcon } from "lucide-react";

interface FeatureCardProps {
  icon: LucideIcon;
  title: string;
  description: string;
}

export const FeatureCard = ({
  icon: Icon,
  title,
  description,
}: FeatureCardProps) => {
  return (
    <Card className="group bg-white border border-slate-200/80 hover:border-slate-300 transition-all duration-300 hover:shadow-xl hover:-translate-y-1 rounded-xl">
      <CardContent className="p-6">
        <div className="w-12 h-12 rounded-full bg-gradient-to-br from-blue-500 to-blue-600 flex items-center justify-center mb-5 shadow-md">
          <Icon className="h-5 w-5 text-white" />
        </div>

        <h3 className="font-semibold text-slate-900 mb-3 text-lg">{title}</h3>
        <p className="text-slate-600 text-sm leading-relaxed">{description}</p>
      </CardContent>
    </Card>
  );
};
